<div class="dialog-title mat-tab-label-active text-muted font-family px-3">
  <div>{{"my-statements"|translate}}</div>

  <div>
    <button cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle mat-icon-button class="drag-handler text-center" style="cursor: grab;">
      <mat-icon style="font-size: 18px;">open_with</mat-icon>
    </button>
    <button mat-icon-button class="text-center" mat-dialog-close>
      <mat-icon style="font-size: 18px;">close</mat-icon>
    </button>
  </div>
</div>

<body id="dark" class="noprint">
  <mat-progress-bar mode="indeterminate" *ngIf="isInvoicesLoading"></mat-progress-bar>
  <div class="text-center text-color-theme" style="padding-top:20px ;">
    <h2>{{'my-statements'|translate}}</h2>
  </div>
  <br>


  <div class="row d-flex justify-content-center m-2 mb-4">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
      <label class="text-color-theme" style="float: right;">{{"select-account" |translate}}</label>
      <ng-select [(ngModel)]="selectedClient" (change)="onUserChanged($event)" appearance="outline" [clearable]="false" class="custom">
        <ng-option *ngFor="let acc of accList" [value]="acc">
          ({{acc.relationCode}})                         <span *ngIf="translate.currentLang === 'en'">
                          {{ acc.clientNameEn }} — {{ acc.accountTypeEn }}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                          <span>{{ acc.clientNameAr }}</span>
                          <span>{{ acc.accountTypeAr }}</span>
                        </span>
        </ng-option>
      </ng-select>
      <!-- <user-selection [isBindValue]="true" [inputUser]="(inputUser!=null)?this.inputUser:null" (userChanged)="selectedClient = $event.relationCode"></user-selection> -->
    </div>

    <div class=" col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex justify-content-center align-items-end">
      <mat-button-toggle-group appearance="legacy" [(ngModel)]="selectedCurr" >
        <mat-button-toggle value='1'>
          <span class="text-color-theme text-sm">{{'egp'|translate}}</span>
        </mat-button-toggle>
        <mat-button-toggle value='2'>
          <span class="text-color-theme text-sm"> {{'usd'|translate}}</span>
        </mat-button-toggle>
        <mat-button-toggle value="-1">
          <span class="text-color-theme text-sm">{{'rated'|translate}}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div class="row d-flex justify-content-center m-2">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
      <label class=" text-color-theme" style="float: right;">{{"date-from"|translate}}</label>

      <input (focus)="pickerFrom.open()" class="form-control" matInput [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom" [max]="maxDate">
      <mat-datepicker #pickerFrom></mat-datepicker>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
      <label class="text-color-theme" style="float: right;">{{"date-to"|translate}}</label>

      <input (focus)="pickerTo.open()" class="form-control" matInput [(ngModel)]="dateTo" [matDatepicker]="pickerTo" [max]="maxDate">
      <mat-datepicker #pickerTo></mat-datepicker>
    </div>
  </div>
  <br>
  <br>
  <div class="row d-flex m-2 mt-4">
    <div class="col-xl-6 col-lg-6 col-md-6 col-12 mt-sm-3 mt-3 mt-xl-0 mt-lg-0 mt-md-0">
      <div class="mb-3 d-flex justify-content-between">
        <div>
          <h6 class="profile-heading text-color-theme">
            {{ "Arabic" | translate }}
          </h6>
        </div>
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="isReportArabic">
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center p-3">
    <button class="btn btn-primary" (click)="onDateChange()" [disabled]="isInvoicesLoading || !selectedClient">
      {{"preview"|translate}}
    </button>

    <div class="p-1 mx-2 text-warning align-self-center">
      {{noStatement}}
    </div>

  </div>
  <br>
  <app-statement-details id="print-section" ></app-statement-details>
</body>

<!-- <app-statement-details id="print-section" ></app-statement-details> -->
